import { ColumnMapDefinition } from '../domainObjects/columnMapDefinition';

export class ColumnMapDefinitionModel {
    index = 0;
    id?: number;
    columnName = '';
    targetColumnName?: string;
    dataType?: string = null;
    pyDataType?: string = null;
    description: string;
    deletePlaceholderRow: string;
    showPlaceholderDelbtn: boolean = false;

    constructor(
      id: number,
      index: number,
      columnName: string,
      dataType: string,
      pyDataType: string,
      description: string,
      showPlaceholderDelbtn: boolean,
      targetColumnName?: string
      ) {
      this.id = id;
      this.index = index;
      this.columnName = columnName;
      this.targetColumnName = targetColumnName;
      this.dataType = dataType;
      this.pyDataType = pyDataType;
      this.description = description;
      this.showPlaceholderDelbtn = showPlaceholderDelbtn;
    }

    toColumnMapDefinition(): ColumnMapDefinition {
      // console.log('Check this', this)
      return new ColumnMapDefinition(this.id, this.columnName, this.targetColumnName, this.dataType, this.pyDataType);
    }
}
